import { supabase } from '../lib/supabase';

export const createCheckoutSession = async (priceId: string) => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    
    if (!session) {
      throw new Error("User must be logged in to purchase credits.");
    }

    // Call the Vercel API Route instead of Supabase Edge Function
    const response = await fetch('/api/checkout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`, // Pass the user's token
      },
      body: JSON.stringify({ priceId }),
    });

    const data = await response.json();

    if (!response.ok) {
        throw new Error(data.error || "Failed to create checkout session");
    }
    
    if (data?.url) {
      // Redirect user to Stripe Checkout
      window.location.href = data.url;
    } else {
      throw new Error("No checkout URL returned");
    }
  } catch (error) {
    console.error("Payment Error:", error);
    throw error;
  }
};